export default __webpack_public_path__ + "static/media/twitter_icon.59318a6b.png";